/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'transactions': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M22.94 4.293a.968.968 0 011.07-.217 1 1 0 01.605.924v20c0 .552-.439 1-.98 1H6.98A.99.99 0 016 25V5a1 1 0 01.606-.924.968.968 0 011.07.217l1.572 1.603a.71.71 0 001.018 0l1.572-1.603a.972.972 0 011.388 0L14.8 5.896a.71.71 0 001.018 0l1.572-1.603a.972.972 0 011.388 0l1.573 1.603a.71.71 0 001.017 0l1.573-1.603zm-1.516 7.04H9.093a.99.99 0 00-.981 1c0 .553.439 1 .98 1h12.332a.99.99 0 00.982-1c0-.552-.44-1-.982-1zm-5.051 4h.476a.99.99 0 01.981 1c0 .553-.44 1-.981 1H9.093a.99.99 0 01-.981-1c0-.552.439-1 .98-1h7.28zm-2.879 4h5.84a.99.99 0 01.982 1c0 .553-.44 1-.981 1H9.093a.99.99 0 01-.981-1c0-.552.439-1 .98-1h4.402z" _fill="#fff"/>'
  }
})
